import CustomMultiSelect from './CustomMultiSelect.jsx';
import './CustomMultiSelect.less';

export default CustomMultiSelect; 